import React from "react";
import { useTranslation } from "react-i18next";

interface CustomCheckboxProps {
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    id?: string;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
                                                           checked,
                                                           onChange,
                                                           id = "custom-checkbox",
                                                       }) => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center gap-2 cursor-pointer">
            <input
                type="checkbox"
                id={id}
                className="hidden"
                checked={checked}
                onChange={onChange}
            />

            <label htmlFor={id} className="flex items-center">
                <img
                    src={
                        checked
                            ? "/images/selectedbutton.svg"
                            : "/images/dontactionbutton.svg"
                    }
                    className="w-5 h-5"
                    alt={checked ? "checked" : "unchecked"}
                />
                <span className="ml-2 text-[13px] font-medium leading-4 text-[#FFFFFF]">
          {t("contactForm.agreed")}
        </span>
            </label>
        </div>
    );
};

export default CustomCheckbox;
